// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DSkK","label":"styles_label__3e9ux"};